import React, { Component, ReactElement } from 'react';

import { bool, expression, func, number, oneOf, string } from '@philips-emr/tws-core/lib/component/prop-types';
import { msg } from '@philips-emr/tws-core/lib/services/message-service';
import { enumValues } from '@philips-emr/tws-utils';

import { Link } from '..';
import ProgressBar from '../file-uploader/progress-bar/progress-bar';

import FileUploaderStatus from './file-uploader-status';

import './file.scss';

export interface FileProps {
  cancelUploadExpression: string;
  failedUploadExpression: string;
  onCancel: () => void;
  onPreview: () => void;
  onRemove: () => void;
  onRetry: () => void;
  previewFileExpression: string;
  progress?: number;
  readOnly: boolean;
  retryUploadExpression: string;
  size: number;
  status?: FileUploaderStatus;
  title: string;
}

class File extends Component<FileProps> {

  static propTypes = {
    cancelUploadExpression: expression,
    failedUploadExpression: expression,
    onCancel: func,
    onPreview: func,
    onRemove: func,
    onRetry: func,
    previewFileExpression: expression,
    progress: number,
    readOnly: bool,
    retryUploadExpression: expression,
    size: number,
    status: oneOf(enumValues(FileUploaderStatus)),
    title: string,
  };

  static defaultProps = {
    percentage: 0,
  };

  renderFileActions(): ReactElement {
    const { cancelUploadExpression, onCancel, onPreview, onRemove, onRetry, previewFileExpression, readOnly, retryUploadExpression, status } = this.props;

    const { ABORTED, DONE, ERROR, PENDING } = FileUploaderStatus;

    const isStatus = (desiredStatus: string): boolean => status === desiredStatus;

    if (readOnly) {
      return (
        <React.Fragment>
          {isStatus(DONE) && (
            <Link className="c-file__message" onClick={onPreview} value={msg(previewFileExpression)} />
          )}
        </React.Fragment>
      );
    }

    return (
      <>
        {isStatus(DONE) && (
          <Link className="c-file__remove" onClick={onRemove} value="" />
        )}

        {(isStatus(ERROR) || isStatus(ABORTED)) && (
          <Link onClick={onRetry} value={msg(retryUploadExpression)} />
        )}

        {isStatus(PENDING) && (
          <Link className="c-file__cancel" onClick={onCancel} value={msg(cancelUploadExpression)} />
        )}
      </>
    );
  }

  render(): ReactElement {
    const { failedUploadExpression, progress, size, status, title } = this.props;

    return (
      <li className="c-file">
        <span className="c-file__name">{title} </span>
        <div className="c-file__status">
          <ProgressBar status={status} progress={progress} size={size} failedUploadExpression={failedUploadExpression} />
          {this.renderFileActions()}
        </div>
      </li>
    );
  }
}

export default File;
